<!-- TEMPLATE -->
<template>
  <div class="perspectives-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
              <span class='avenir-heavy'>Logboeken</span>
          </span>
        </dean-section-title>

        <div class="filter">
          <dean-form-row
              @input="update(true)"
              v-model="pageMeta.query"
              class="top-bar"
              :hide-label="true"
          >Filter</dean-form-row>
        </div>

        <dean-table
          :data='messages'
          :columns="columns"
          @cell-click="cellClick"
          :hover="true"
          :showLayoutButtons="false">
        </dean-table>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import { Component } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import {mixins} from 'vue-class-component';

  import {
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
  } from '@deanone/dean-components';
  import DeanIcon from '@/components/deanComponents/deanIcon.vue';
  import deanFormRow from "@/components/deanComponents/deanFormRow.vue";
  import {getDutchLongDateFormat} from "@/mixins/dateWrapper";
  import {deanDialogBus} from "@/main";

  interface Message {
    id: number;
    type: string;
    createdAt: string;
    message: string;
    stackTrace: string|null;
  };

  @Component({
    components: {
      DeanIcon,
      deanFormRow,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
    },
  })

  export default class Details extends mixins(deanTableMixin, sideMenuAdminMixin) {
    public sideMenu: object = {
      title: {
        text: 'Logboeken',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };

    public queryTimeout!: number;

    // DATA

    private messages: Array<Message> = [];

    public columns: any = {
      id: {
        content: 'ID',
        align: 'center',
        sort: false,
        dql: 'id',
      },
      type: {
        content: 'Type',
        align: 'center',
        sort: false,
        dql: 'type',
      },
      createdAt: {
        content: 'Created at',
        align: 'center',
        sort: false,
        dql: 'createdAt',
      },
      message: {
        content: 'Message',
        align: 'left',
        sort: false,
        dql: 'message',
      },
    };

    // METHODS
    public loadList() {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/admin.log.info', {
        'filename': this.$route.params.filename,
        'filter': this.pageMeta.query,
      })
      .then(
        (response: any) => {
          this.messages = this.messagesFactory(response.data);
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    private messagesFactory(items: object): Array<Message> {
      let messages: Array<Message> = [];

      Object.values(items).forEach((item: any) => {
        let message: Message = {
          id: item.id,
          type: item.type,
          createdAt: getDutchLongDateFormat(item.createdAt),
          message: item.message,
          stackTrace: item.stackTrace,
        };

        messages.push(message);
      })

      return messages;
    }

    public cellClick(target: { cell: object, row: Message, column: string }) {
      deanDialogBus.$emit('open', 'ViewLogStackTrace', target.row);
    }

    public created() {
      this.keepMetaSavedInState();
      this.setDefaultSort('id');
      this.loadList();
      this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
    }

    public update(timeout: boolean|null = null) {
      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList();
        }, 800);
      } else {
        this.loadList();
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

.filter {
  display: flex;
}

:deep(.dean-table table td) {
  vertical-align: top;
  overflow-wrap: break-word;
  word-break: break-word;
}

</style>